import React from 'react';
import { Link } from 'react-router-dom';

function Main() {
  return (
    <div>
      <footer className="site-footer site-footer-four">
        <div className="site-footer-four-shape-1" />
        <div className="site-footer-four-shape-2" />
        <div className="site-footer-four-shape-3" />
        <div className="site-footer-four-shape-4" />
        <div className="container">
          <div className="footer-main footer-main-four">
            <div className="row">
              <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12">
                <div
                  className="footer-widget footer-widget-about wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="700ms"
                >
                  <h3 className="footer-widget-about-four-title">
                    Boost Your Website &amp; SEO Camping ?
                  </h3>
                  <ul className="footer-widget-about-details footer-widget-about-details-four">
                    <li>
                      <i className="icon-sms-box" />
                      <Link to="/mailto:support@gmail.com">support@gmail.com</Link>
                    </li>
                    <li>
                      <i className="icon-call-icon" />
                      <Link
                        to="/tel:+000(123)45688"
                        className="footer-widget-number"
                      >
                        +000 (123) 456 88
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12">
                <div
                  className="footer-widget footer-widget-address footer-widget-address-four wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <h5 className="footer-widget-address-four-title">
                    Location
                  </h5>
                  <p className="footer-widget-address-details-four">
                    55 Main Street, 2nd block Malborne, Australia
                  </p>
                  <ul className="footer-widget-social footer-widget-social-four">
                    <li>
                      <Link to="#">
                        <i className="icon-facebook-f" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-linkedin-in" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom footer-bottom-four">
            <div
              className="footer-bottom-inner footer-bottom-inner-four wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <ul className="footer-bottom-inner-item">
                <li>
                  <Link to="/faq">FAQs</Link>
                </li>
                <li>
                  <Link to="/about">Company</Link>
                </li>
                <li>
                  <Link to="/contact">Privacy</Link>
                </li>
              </ul>
              <div className="copyright">
                <p>
                  © 2024 · <Link to="/">Zoso</Link>, All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Main
